module.exports = __webpack_public_path__ + "static/img/dzcdhp.c5ca9ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/dzcdhp.png
// module id = GrvJ
// module chunks = 70